/* Luminaire France — Footer JS */

(function () {
  'use strict';

  function initLuminaireFooter() {
    var footers = document.querySelectorAll('.lf-footer');

    if (!footers.length) {
      return;
    }

    footers.forEach(function (footer) {
      if (footer.dataset.lfAccordionReady === 'true') {
        return;
      }

      footer.dataset.lfAccordionReady = 'true';

      var columns = footer.querySelectorAll('.lf-col');

      if (!columns.length) {
        return;
      }

      var mobile = window.matchMedia(
        '(max-width: 700px)'
      );

      function closeColumn(column) {
        column.classList.remove('is-open');

        var title = column.querySelector('h3');

        if (title) {
          title.setAttribute(
            'aria-expanded',
            'false'
          );
        }
      }

      function closeOthers(current) {
        columns.forEach(function (column) {
          if (column !== current) {
            closeColumn(column);
          }
        });
      }

      columns.forEach(function (column) {
        var title = column.querySelector('h3');

        if (!title) {
          return;
        }

        title.setAttribute(
          'role',
          'button'
        );

        title.setAttribute(
          'tabindex',
          '0'
        );

        title.setAttribute(
          'aria-expanded',
          'false'
        );

        function toggleColumn() {
          if (!mobile.matches) {
            return;
          }

          var opened =
            column.classList.contains(
              'is-open'
            );

          closeOthers(column);

          if (opened) {
            closeColumn(column);
          } else {
            column.classList.add(
              'is-open'
            );

            title.setAttribute(
              'aria-expanded',
              'true'
            );
          }
        }

        title.addEventListener(
          'click',
          toggleColumn
        );

        title.addEventListener(
          'keydown',
          function (event) {
            if (
              event.key === 'Enter' ||
              event.key === ' '
            ) {
              event.preventDefault();
              toggleColumn();
            }
          }
        );
      });

      function handleBreakpoint() {
        if (!mobile.matches) {
          columns.forEach(
            closeColumn
          );
        }
      }

      if (
        typeof mobile.addEventListener ===
        'function'
      ) {
        mobile.addEventListener(
          'change',
          handleBreakpoint
        );
      } else {
        mobile.addListener(
          handleBreakpoint
        );
      }

      handleBreakpoint();
    });
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initLuminaireFooter,
      {
        once: true
      }
    );
  } else {
    initLuminaireFooter();
  }

})();

/* Footer: raccourci de suivi des commandes dans Infos utiles. */
(function () {
  'use strict';
  function addOrderTrackingLink() {
    var footer = document.querySelector('#lf49-footer');
    if (!footer) return false;
    var columns = footer.querySelectorAll('.lf49-footer__column');
    var infoColumn = Array.prototype.find.call(columns, function (column) {
      var heading = column.querySelector('.lf51-footer-accordion__summary h3, h3');
      return heading && heading.textContent.trim().toLowerCase() === 'infos utiles';
    });
    if (!infoColumn) return false;
    var list = infoColumn.querySelector('.lf51-footer-accordion__body ul, ul');
    if (!list || list.querySelector('a[href="/account"]')) return !!list;
    var item = document.createElement('li');
    var link = document.createElement('a');
    link.href = '/account';
    link.textContent = 'Suivre ma commande';
    item.appendChild(link);
    list.appendChild(item);
    return true;
  }
  var observer;
  function tryAdd() {
    if (addOrderTrackingLink() && observer) observer.disconnect();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryAdd, { once: true });
  }
  observer = new MutationObserver(tryAdd);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  tryAdd();
})();
